<template>
  <div 
    @mouseenter="applied_payment.hovered = true" 
    @mouseleave="applied_payment.hovered = false"
    :id="`applied_payment-${applied_payment.id}`"
    :class="{hovered:applied_payment.hovered, 'is-recent':applied_payment.isRecent}" 
    class="payment-fragment flex-center" 
    :style="getPaymentWidth(charge, applied_payment)"
    v-for="applied_payment in charge.applied_payments" 
    :key="applied_payment.id">
      <div :class="{hovered:applied_payment.hovered}" class="payment-fragment-container">
        <p v-if="!applied_payment.isShort" @mouseenter="isShort(applied_payment)" class="m-0">${{-applied_payment.amount}}</p>
        <p v-if="applied_payment.isShort" class="val1">${{formatCurrency(-applied_payment.amount)}}</p>
        <p class="val2">${{-applied_payment.amount}} on {{moment(applied_payment.transaction_date).format('MM/DD/YY')}}</p>
      </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    charge: Object,
    elemType: {
      type: [Boolean, String],
      default: false
    }
  },
  created() {
    this.moment = moment
  },
  mounted() {
    this.charge.applied_payments.forEach(applied_payment => { 
      applied_payment.hovered = false
      applied_payment.isShort = false
    })

    if (this.$page.props.payment) {
      const paymentId = this.$page.props.payment.id
      this.charge.applied_payments.forEach(applied_payment => {
        if (applied_payment.payment_id === paymentId) applied_payment.isRecent = true
      })
    }
  },
  methods: {
    getPaymentWidth(charge, applied_payment) {
      const percentage = Math.round((-applied_payment.amount / -charge.appliedPaymentsTotal)*100)
      return `width: ${percentage}%;`
    },
    isShort(applied_payment) {
      const appliedPaymentElement = document.getElementById(`applied_payment-${applied_payment.id}`)
      return appliedPaymentElement.offsetWidth >= 75 ? applied_payment.isShort = false : applied_payment.isShort = true
    },
  }
}
</script>
